import React from "react"
import styled from "styled-components"
import { useTranslation } from "next-i18next"

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin: 0 5rem 0 5rem;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin: 0 2rem;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    margin: 0 0.5rem;
    width: 100%;
    overflow-x: hidden;
  }
`

const SceneCard = styled.div`
  background: #081d50;
  border-radius: 18px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.03);
  padding: 2.2rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 320px;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 6px 24px 0 rgba(0, 0, 0, 0.09);
  }
`

const SceneTitle = styled.div`
  font-weight: 700;
  font-size: 1.7rem;
  color: #ffc211;
  margin-bottom: 0.7rem;
`

const SceneSubtitle = styled.div`
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 2rem;
`

const SceneList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
`

const SceneListItem = styled.li`
  font-size: 1rem;
  color: #fff;
  margin-bottom: 0.5rem;
  font-weight: 300;
  display: flex;
  align-items: center;
  gap: 0.5em;
`

const CheckIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M5 11.5L9 15.5L17 7.5"
      stroke="#ffc211"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

import p2pImage from "@/common/assets/image/products/transfer/p2p.png"
import b2cImage from "@/common/assets/image/products/transfer/b2c.png"
import globeImage from "@/common/assets/image/products/transfer/globe.png"

const TransferSceneCards = () => {
  const { t } = useTranslation("transfer")

  return (
    <CardGrid>
      <SceneCard>
        <img
          src={p2pImage.src}
          alt="P2P"
          style={{ width: 80, height: 80, marginBottom: 12 }}
        />
        <SceneTitle>{t("Scenario.card1.title")}</SceneTitle>
        <SceneSubtitle>{t("Scenario.card1.subtitle")}</SceneSubtitle>
        <SceneList>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card1.list.0")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card1.list.1")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card1.list.2")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card1.list.3")}
          </SceneListItem>
        </SceneList>
      </SceneCard>
      <SceneCard>
        <img
          src={b2cImage.src}
          alt="B2C"
          style={{ width: 80, height: 80, marginBottom: 12 }}
        />
        <SceneTitle>{t("Scenario.card2.title")}</SceneTitle>
        <SceneSubtitle>{t("Scenario.card2.subtitle")}</SceneSubtitle>
        <SceneList>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card2.list.0")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card2.list.1")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card2.list.2")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card2.list.3")}
          </SceneListItem>
        </SceneList>
      </SceneCard>
      <SceneCard>
        <img
          src={globeImage.src}
          alt="Cross Border"
          style={{ width: 80, height: 80, marginBottom: 12 }}
        />
        <SceneTitle>{t("Scenario.card3.title")}</SceneTitle>
        <SceneSubtitle>{t("Scenario.card3.subtitle")}</SceneSubtitle>
        <SceneList>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card3.list.0")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card3.list.1")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card3.list.2")}
          </SceneListItem>
          <SceneListItem>
            <CheckIcon />
            {t("Scenario.card3.list.3")}
          </SceneListItem>
        </SceneList>
      </SceneCard>
    </CardGrid>
  )
}

export default TransferSceneCards
